import React from "react";
import { Link } from "react-router-dom";
import classes from "./dashboard.module.scss";

const desktopCards = [
  {
    path: "/user/profile",
    title: "Personal Details",
    desc: "Edit account & personal informations",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    path: "/my-orders",
    title: "Your Orders",
    desc: "View and manage your orders",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
  },
  {
    path: "/user/profile",
    title: "Your Address Book",
    desc: "Edit addresses for orders and gifts",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 19.5A2.5 2.5 0 0 0 6.5 22h11A2.5 2.5 0 0 0 20 19.5V4.5A2.5 2.5 0 0 0 17.5 2h-11A2.5 2.5 0 0 0 4 4.5v15z" />
        <path d="M8 7h8" />
        <path d="M8 12h8" />
        <path d="M8 17h5" />
      </svg>
    ),
  },
  {
    path: "/wishlists",
    title: "Wishlist",
    desc: "View your wish-listed products",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    path: "/change-password",
    title: "Change Password",
    desc: "Update your account password",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
  },
];

const DesktopDashboard = () => {
  return (
    <div data-component="DesktopDashboard" className={classes.desktop_home}>
      <div className={classes.header_wrap}>
        <h2 className={classes.heading}>Dashboard</h2>
      </div>

      <div className={classes.card_grid}>
        {desktopCards.map((card) => (
          <Link
            key={`${card.path}-${card.title}`}
            to={`${process.env.PUBLIC_URL}${card.path}`}
            className={classes.card}
          >
            <div className={classes.card_icon}>{card.icon}</div>
            <h3 className={classes.card_title}>{card.title}</h3>
            <p className={classes.card_desc}>{card.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DesktopDashboard;
